import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { trigger, style, transition, animate, keyframes } from '@angular/animations';
import { PermitApplicationService, PermitApplicationFormData } from 'src/app/services/permit-application.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApplicationPackageService, ApplicationPackage } from 'src/app/services/application-package.service';
import { PodsService, Pod } from 'src/app/services/pods.service';
import { DblistService, ListProjectType } from 'src/app/services/dblist.service';

@Component({
  selector: 'app-application-form',
  animations: [
    trigger('openClose', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('0.25s', keyframes([
          style({ height: 0, opacity: 0, offset: 0 }),
          style({ height: '*', opacity: 1, offset: 1 }),
        ]))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, }),
        animate('0.25s', keyframes([
          style({ height: '*', opacity: 1, offset: 0 }),
          style({ height: 0, opacity: 0, offset: 1 }),
        ]))
      ])
    ])
  ],
  templateUrl: './application-form.component.html',
  styleUrls: ['./application-form.component.scss']
})
export class ApplicationFormComponent implements OnInit {

  @ViewChild('f', {static: false}) appForm: NgForm;

  @Input() appShow: boolean;
  @Input() url: string;
  @Input() printMode?: boolean = false;

  @Output() submitEvent = new EventEmitter<null>();
  @Output() hideEvent = new EventEmitter<null>();

  applicationInitial: PermitApplicationFormData;
  applicationData: PermitApplicationFormData;
  applicationSubmitted: boolean;
  editMode: boolean = true;

  applicationPackage: ApplicationPackage = null;
  pod: Pod = null;

  listProjectTypes: ListProjectType[] = [];
  appDataProjectTypeId: number = 0;

  private unsubscribe: Subject<any> = new Subject();

  constructor(
    private appService: PermitApplicationService,
    private applicationPackageService: ApplicationPackageService,
    private dbListService : DblistService,
    private podsService: PodsService) { }

  ngOnInit() {

    this.applicationInitial = {
      applicationPackageId: null,
      projectTypeId: null,
      projectTypeName: null,
      sourceName: null,
      diversionTypeId: null,
      diversionTypeName: null,
      diversionStructureName: null,
      diversionCFSMax: null,
      maximumCFSRequested: null,
      minimumCFSNeeded: null,
      ifNotCompletedWhenWillItBeDate: null,
      earliestDateForDiversion: null,
      federalAssistance: null,
      isThereSecondaryPurpose: null,
      ifSecondaryPurposeHowMany: null,

      // Needs to be fetched from the PermitPointOfDiversion for the associated ApplicationPackage.PermitPointOfDiversion.<attributeName>
      //ppod_sourceName: null,
      //ppod_diversionType: null,
      //ppod_canalName: null,
      //ppod_deliveryMax: null, // maximumCFSCapable

      //// variance?: string, // permitVariance
      //varianceId: null, // permitVarianceId
      //// version?: number,
      //priorityDate: null,
      //approvalDate: null,
      //leadSpecialist: null,
      //primaryPurpose: null, // purposeOfProject
      //secondary: null, // isThereSecondaryPurpose
      //secondaryHowMany: null,
      //secondaryPurpose: null, // purposeOfProjectSecondary
      //deliveryMin: null,
      //requestedMax: null, // maximumCFSRequested
      //leadTime: null, // leadTimeForNotificationInDays
      //longitude: null, // locationLongitude
      //latitude: null, // locationLatitude
      //distanceFromRiver: null, // distanceFromRiver
      //diversionPoint: null, // locationDiversionLatitude & locationDiversionLongitude
      //completionTime: null, // timeToCompleteDiversionHours
      //// approvedByUserId?: string,
      //// approvedDatetime?: any

      //coldWeather: null,
      //applicationType: null,
      //federalAssistance: null,
      //operationalConstraints: null,
      //earliestDiversionDate: null,
      //projectTypeId: null,
      canEdit: true,
      waterRightsId: null,
      applicationNumber: null
    }

    this.applicationData = this.applicationInitial;
    this.appDataProjectTypeId = 0;

    this.appService.currentApplication
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(application => {
      if (!!application) {
        this.applicationData = application;
        this.submitEvent.emit();
        this.applicationSubmitted = true;
        this.editMode = false;
      } else {
        this.applicationData = this.applicationInitial;
      }
    });

    this.applicationPackageService.currentApplicationPackage
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(applicationPackage => {
      if (!!applicationPackage) {
        this.applicationPackage = applicationPackage;
      }
    });

    this.podsService.currentPodByPodId
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(pod => {
      if (!!pod) {
        this.pod = pod;
      }
    });

    this.dbListService.getListProjectType();
    this.dbListService.listProjectType$
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(pt => {
      if (!!pt) {
        this.listProjectTypes = pt;
      }
    });

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


  updateApplicationProjectTypeId($event) {
    this.appDataProjectTypeId = 0;
    var selProjectTypeName = $event.currentTarget.value;
    for (var i =0; i< this.listProjectTypes.length; i++) {
      if (this.listProjectTypes[i].name === selProjectTypeName) {
        this.appDataProjectTypeId = this.listProjectTypes[i].listProjectTypeId;
        break;
      }
    }
  }

  submit($event: Event) {
    if (this.appDataProjectTypeId > 0) {
      this.applicationData.projectTypeId = this.appDataProjectTypeId;
    }
    if (this.applicationSubmitted === true) {
      this.appService.putApplication(this.applicationData, this.applicationPackage);
    } else {
      this.appService.postApplication(this.applicationData, this.applicationPackage);
      this.applicationSubmitted = true;
    }
    this.editMode = false;
    this.appDataProjectTypeId = 0;
    this.submitEvent.emit();
    this.hideEvent.emit();
  }

  edit() {
    this.editMode = true;
  }

}
